import AdvanceSetting from "./AdvanceSetting";
import ShopInfo from "./ShopInfo";
import "./Setting.scss";
import UserTable from "./UserTable";
export default function Setting(props) {
  return (
    <section className="py-4 setting">
      <div className="container">
        <div className="bg-white shadow rounded-lg d-block ">
          <div className="profile-tab-nav border-right">
            <div className="burger-menu">
              <i className="fa fa-bars"></i>
            </div>
            <ul className="nav nav-pills" role="tablist">
              <li className="nav-item">
                <a
                  className="nav-link active"
                  id="newuser-tab"
                  data-bs-toggle="pill"
                  href="#user-define"
                >
                  <i className="fa fa-home text-center mr-1" /> فهرست کاربران
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link"
                  id="store-spec"
                  data-bs-toggle="pill"
                  href="#store"
                >
                  <i className="fa fa-store text-center mr-1" /> مشخصات فروشگاه
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link"
                  id="print-tab"
                  data-bs-toggle="pill"
                  href="#advanced"
                >
                  <i className="fas fa-cogs text-center mr-1" /> تنظیمات پیشرفته
                </a>
              </li>
            </ul>
          </div>
          <div className="tab-content p-4 p-md-5">
            <div className="tab-pane  active" id="user-define">
              <UserTable />
            </div>
            <div className="tab-pane fade" id="store">
              <ShopInfo />
            </div>
            <div className="tab-pane fade" id="advanced">
              <AdvanceSetting isLog={false} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
